import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface client {
    id: number;
    name: string;
    account_no: number;
    serial_no: number;
    phone: string;
    email: string;
    address_1?: string;
    tax_number?: string;
}
interface iClient{[key:number]:client[] | null}
// Clients state
export interface clientsState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    clients: iClient,
    page:number
}

const initialClientsState: clientsState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    clients: {
        1:[]
    },
    page:1

}

// Clients slice
export const clientsSlice = createSlice({
    name: 'clients',
    initialState: initialClientsState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        initializeClients: (state, { payload }: PayloadAction<client[]>) => {
            state.clients[state.page] =[...payload]
        },
        addClients: (state, { payload }: PayloadAction<client[]>) => {
            state.clients[state.page] =state.clients[state.page]?
             [...(state.clients[state.page]??[] ), ...payload]:[...payload]
        },
        updateClient: (state, { payload }: PayloadAction<client>) => {
            
            let index = state.clients[state.page]?.findIndex(client => client.id === payload.id)
            if (index && index !== -1 )
                state.clients[state.page]![index] = payload
            
        },
        deleteClients: (state, { payload }: PayloadAction<number[]>) => {
            payload.map(id => {
                let index = state.clients[state.page] !.findIndex(client => client.id === id)
                if (index != -1)
                    state.clients[state.page]!.splice(index, 1)
            })
        },
        reset: (state) => {
            state.clients = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})